import {useState, useEffect, useRef} from 'react'
import {connect} from 'react-redux'
import {Map} from 'immutable'
import PropTypes from 'prop-types'
import {deleteResource, readEndpoint} from 'redux-json-api'

import {cleanResponse} from '../redux/apiHelper'
import {useNotificationContext} from '../../../../../shared_components/notifications/NotificationContext'

import MemorialGuideDownloadStatus from './MemorialGuideDownloadStatus'
import {downloadWithFetch} from '../../../../../lib/fileDownload'

const POLLING_TIME_INTERVAL = 20000

const MemorialGuideDownloadStatusController = props => {
  const [jobId, setJobId] = useState(null)
  const {alwaysNotify} = useNotificationContext()
  const prevDownloadRef = useRef(props.memorialGuideDownload)

  const clearDownloadPolling = () => {
    const bundle_url = props.memorialGuideDownload.get('presigned-url')

    if (jobId) {
      clearInterval(jobId)
      setJobId(null)
    }

    if (bundle_url) {
      downloadWithFetch(bundle_url)
      alwaysNotify.shortSuccess('Memorial guide download is complete.')

      const payload = {
        type: 'memorial-guide-downloads',
        id: props.memorialGuideDownload.get('id')
      }

      setTimeout(() => props.deleteResource(payload), 1000) // 1 second
    }
  }

  const startDownloadPolling = memorialGuideDownloadId => {
    // clear any existing download polling before starting a new one.
    clearDownloadPolling()
    setJobId(setInterval(
      () => props.readEndpoint(`memorial-guide-downloads/${memorialGuideDownloadId}`),
      POLLING_TIME_INTERVAL
    ))
  }

  useEffect(() => {
    const prevDownload = prevDownloadRef.current
    const currentDownload = props.memorialGuideDownload

    if (
      !currentDownload.isEmpty() &&
      !currentDownload.equals(prevDownload)
    ) {
      currentDownload.get('status') === 'ready' ?
        clearDownloadPolling() :
        startDownloadPolling(currentDownload.get('id'))
    }

    prevDownloadRef.current = currentDownload
  }, [props.memorialGuideDownload])

  useEffect(() => () => clearDownloadPolling(), [])

  return (
    <MemorialGuideDownloadStatus
      memorialGuideDownload={props.memorialGuideDownload}
    />
  )
}

MemorialGuideDownloadStatusController.propTypes = {
  deleteResource: PropTypes.func,
  memorialGuideDownload: PropTypes.instanceOf(Map),
  readEndpoint: PropTypes.func
}

const mapStateToProps = ({api}) => ({
  memorialGuideDownload: cleanResponse(api['memorial-guide-downloads']).sortBy(
    download => download.get('created-at')
  ).last() || Map()
})

export default connect(mapStateToProps, {deleteResource, readEndpoint})(MemorialGuideDownloadStatusController)
